// src/pages/admin/OverviewStats.js (example)
import React from 'react';
import { Row, Col, Statistic } from 'antd';
import { FaUsers, FaChalkboardTeacher, FaStore, FaBook, FaProjectDiagram, FaBell, FaMoneyBillWave, FaCertificate } from 'react-icons/fa';

const OverviewStats = ({ data }) => (
  <Row gutter={[16, 16]}>
    <Col xs={12} sm={8} md={6}><Statistic title="Total Users" value={data.totalUsers} prefix={<FaUsers />} /></Col>
    <Col xs={12} sm={8} md={6}><Statistic title="Mentors" value={data.mentors} prefix={<FaChalkboardTeacher />} /></Col>
    <Col xs={12} sm={8} md={6}><Statistic title="Students" value={data.students} prefix={<FaUsers />} /></Col>
    <Col xs={12} sm={8} md={6}><Statistic title="Active Vendors" value={data.vendors} prefix={<FaStore />} /></Col>
    <Col xs={12} sm={8} md={6}><Statistic title="Published Courses" value={data.courses} prefix={<FaBook />} /></Col>
    <Col xs={12} sm={8} md={6}><Statistic title="Active Projects" value={data.projects} prefix={<FaProjectDiagram />} /></Col>
    <Col xs={12} sm={8} md={6}><Statistic title="Pending Alerts" value={data.alerts} prefix={<FaBell />} /></Col>
    <Col xs={12} sm={8} md={6}><Statistic title="Total Revenue" value={data.revenue} prefix={<FaMoneyBillWave />} suffix="$" /></Col>
    <Col xs={12} sm={8} md={6}><Statistic title="Certificates Issued" value={data.certificates} prefix={<FaCertificate />} /></Col>
  </Row>
);

export default OverviewStats;